import React from "react";
import { useTranslation } from "react-i18next";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Cell,
  Tooltip,
} from "recharts";

const data = [
  { type: "EV", range: 420, color: "#F9A21B" },
  { type: "ICE", range: 480, color: "#0F1B2B" },
];

export const RangeBarChart: React.FC = () => {
  const { t } = useTranslation("calculator");
  const rows = data.map((row) => ({
    ...row,
    type: t(row.type === "EV" ? "ev" : "ice"),
  }));
  return (
    <div style={{ width: "100%", height: 150 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={rows}
          margin={{ right: 30, bottom: 20, top: 20 }}
        >
          <XAxis
            type="number"
            tick={{ fontSize: 12, fill: "#000" }}
            axisLine={{ stroke: "#000" }}
            tickLine={{ stroke: "#000" }}
            label={{
              value: t("range"),
              position: "bottom",
              offset: 0,
              fontSize: 20,
              fontWeight: "bold",
              fill: "#000",
            }}
          />
          <YAxis
            type="category"
            dataKey="type"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 14, fontWeight: "bold", fill: "#000" }}
          />
          <Tooltip />
          <Bar dataKey="range" barSize={15}>
            {rows.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
